export default __webpack_public_path__ + "static/media/OverShadows.b5bf571d.png";